export type NameType = 'mqUp';

export const name: NameType = 'mqUp';
